import React, { FC, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import SuccessAnime from 'assets/lottie/waiting.json';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import Lottie from 'react-lottie';
import SendIcon from '@mui/icons-material/Send';
import { IconButton, Tooltip } from '@mui/material';
import { usePolicyStore } from 'Application/store/usePolicyStore'; // Update the path to your store
import { toast } from 'sonner';
import { PolicyFlag } from 'Application/models';
import AppDialog from './AppDialog';

interface PushToAmisProps {
    policyNumber: string;
}

export const PushToAmis: FC<PushToAmisProps> = ({ policyNumber }) => {
    const [open, setOpen] = useState(false);
    const { pushToAMis, isLoading, isError, error } = usePolicyStore();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirm = async () => {
        try {
            const response = await pushToAMis(policyNumber, 1, 10, PolicyFlag.ALL); // Pass necessary parameters

            if (response.error) {
                toast.error(response.message); // Display error message if there's an error
            } else {
                toast.success(response.message); // Display success message
            }

            handleClose(); // Close dialog
        } catch (error) {
            console.error('Failed to push to AIMS:', error);
            toast.error(`An unexpected error occurred. Please try again. ${error}`); // Handle unexpected errors
            handleClose(); // Close dialog after failure
        }
    };

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: SuccessAnime,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <React.Fragment>
            <Tooltip placement="top" title="Push to Aims">
                <IconButton color="primary" onClick={handleClickOpen} size="large">
                    <CloudSyncIcon sx={{ fontSize: '1.1rem', m: 1 }} />
                </IconButton>
            </Tooltip>

            <AppDialog
                Graphic={<Lottie options={defaultOptions} height={100} width={100} />}
                isLoading={isLoading}
                loadingButtonTitle="Pushing..."
                title="Push To Aims"
                description="By Clicking Confirm, This Policy will be pushed to Aims"
                open={open}
                handleClose={handleClose}
                handleConfirm={handleConfirm}
            />
        </React.Fragment>
    );
};
